import {
    Breadcrumbs,
    Button,
    CardActions,
    CardContent,
    Checkbox,
    CircularProgress,
    FormControlLabel,
    Grid,
    IconButton,
    Link,
    Typography,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, { useState } from "react";
import { setShowBotPrivilegeForm } from "../../../redux/botManagement/botManagementSlice";
import { useDispatch, useSelector } from "react-redux";
import { apiGatewayAxiosInstance } from "../../../utils/axios";
import { setErrorMessageForUser } from "../../../redux/userManagement/userManagementSlice";

export default function BotPrivileges({ setOperationStatus }) {
    const state = useSelector(state => state.botManagementSlice);
    const dispatch = useDispatch();
    const [botName, setBotName] = useState(state.controls.showBotPrivilegeForm.botId.botName);
    const [privilegeSave, setPrivilegeSave] = useState(false);

    const [isSupportAPI, setIsSupportAPI] = useState(state.controls.showBotPrivilegeForm.botId.isApiBot ?? false);
    const [isSupportProvider, setIsSupportProvider] = useState(state.controls.showBotPrivilegeForm.botId.isProviderDirectBot ?? false);

    const onClickCancelButton = () => {
        dispatch(setShowBotPrivilegeForm(false));
    };

    const onClickSaveButton = async () => {
        try {
            setPrivilegeSave(true);
            const response = await apiGatewayAxiosInstance.post(`/bot_management/bot/update-bot-privilege`, {
                botData: { isApiBot: isSupportAPI, isProviderDirectBot: isSupportProvider, _id: state.controls.showBotPrivilegeForm.botId._id },
            });

            if (response.status === 200) {
                setOperationStatus({
                    message: "Privilege Updated Successfully.",
                    success: true,
                    failed: false,
                });
                setPrivilegeSave(false);
                onClickCancelButton();
            } else {
                throw new Error(response);
            }
        } catch (error) {
            setPrivilegeSave(false);
            let errorMessage = "Failed to update Bot Privilege";

            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            // setIsUpdateCustomizedRateLoading(false);
            dispatch(
                setErrorMessageForUser({
                    fieldName: "updateBotPrivilegeErrorMessage",
                    errorMessage,
                }),
            );
            throw error;
        }
    };
    return (
        <>
            <Grid container className="listHeader">
                <Grid item md={6} display={"flex"} alignItems={"center"}>
                    <IconButton color="secondary" onClick={onClickCancelButton} size="medium">
                        <ArrowBackIosIcon sx={{ cursor: "pointer" }} />
                    </IconButton>
                    <Grid role="presentation">
                        <Breadcrumbs aria-label="breadcrumb" fontSize="large">
                            <Link
                                underline="hover"
                                color="inherit"
                                className="breadcrumbItem"
                                // href="/rcs-management/manage-bots/"
                                onClick={onClickCancelButton}
                            >
                                Bots
                            </Link>
                            <Typography className="breadcrumbItem" color="text.primary">
                                {/* {botName} - */}
                                Bot Privileges
                            </Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
            </Grid>
            <CardContent>
                <Grid gap={5} display={"flex"}>
                    <Grid>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    disabled={false}
                                    checked={isSupportAPI}
                                    onChange={() => {
                                        setIsSupportAPI(!isSupportAPI);
                                    }}
                                    name="api_support"
                                    size={"small"}
                                />
                            }
                            label="Does this support API"
                        />
                    </Grid>

                    <Grid>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    disabled={false}
                                    checked={isSupportProvider}
                                    onChange={() => {
                                        setIsSupportProvider(!isSupportProvider);
                                    }}
                                    name="direct_provider_support"
                                    size={"small"}
                                />
                            }
                            label="Does this support direct Provider"
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions sx={{ padding: "0px" }}>
                <Grid display={"flex"}>
                    {privilegeSave ? (
                        <Button variant="outlined" className="m-2">
                            <CircularProgress size={15} className="spinner" />
                            Saving..
                        </Button>
                    ) : (
                        <Button variant="contained" type="submit" onClick={onClickSaveButton} className="m-2">
                            Save
                        </Button>
                    )}
                    <Button variant="contained" color="error" onClick={onClickCancelButton} className="m-2">
                        Cancel
                    </Button>
                </Grid>
            </CardActions>
        </>
    );
}
